import React from 'react';

const About = () => {
    return (
        <div>
            <h1>About us is comming soon.....</h1>
        </div>
    );
};

export default About;